// extracted by mini-css-extract-plugin
export default {"bellWrapper":"style_bellWrapper__inrT4"};